import { Button } from "@/components/flexkit/Button";
import { LoadingState } from "@/components/podkit/loading/LoadingState";
import { Heading1, Subheading } from "@/components/podkit/typography/Headings";
import { useDocumentTitle } from "@/hooks/use-document-title";
import { useGetIntegration, useListIntegrationDefinitions } from "@/queries/integration-queries";
import { useOrganization } from "@/queries/organization-queries";
import type { FC } from "react";
import { useParams } from "react-router-dom";

export const IntegrationConnectedPage: FC = () => {
    const { integrationId } = useParams<{ integrationId: string }>();
    useDocumentTitle("Integration Connected");

    const { data: integration, isLoading: isLoadingIntegration } = useGetIntegration(integrationId);
    const { data: definitions, isLoading: isLoadingDefinitions } = useListIntegrationDefinitions();
    const { data: organization, isLoading: isLoadingOrg } = useOrganization();

    const definition = definitions?.find((d) => d.id === integration?.integrationDefinitionId);
    const isLoading = isLoadingIntegration || isLoadingDefinitions;

    const handleClose = () => window.close();

    if (isLoading) {
        return <LoadingState />;
    }

    return (
        <div
            data-testid="integration-connected-page"
            className="flex size-full grow flex-col items-center justify-center px-1 py-4 md:px-8"
        >
            <div className="flex w-96 max-w-[65vw] flex-col items-center justify-start gap-4">
                <Heading1>{`${definition?.name ?? "Integration"} connected`}</Heading1>
                <Subheading className="text-center">
                    <span>
                        {isLoadingOrg ? (
                            <span className="inline-block h-5 w-48 animate-pulse rounded bg-surface-muted" />
                        ) : (
                            <span>
                                Your{" "}
                                <span className="font-bold">{definition?.name ?? "integration"}</span>{" "}
                                account has been connected to the{" "}
                                <span className="font-bold">{organization?.name}</span> organization.
                            </span>
                        )}
                    </span>
                </Subheading>
                <Button
                    variant="primary"
                    onClick={handleClose}
                    data-testid="close-tab-button"
                    data-tracking-id="close-tab"
                >
                    Close tab
                </Button>
            </div>
        </div>
    );
};
